<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>{{ $t('ItemsReport') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                <CButton @click="get_lists" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <br>
          <CRow>
            <CCol col="12">
              <CRow>
                <CCol col="2">
                  <select v-model="selected_place" class="form-control"

                  >
                    <option value="0">
                      {{ $t('components.selectWarehouse') }}
                    </option>
                    <option v-for="option in places_items" v-bind:value="option.id">
                      {{ option.placeName }}
                    </option>
                  </select>
                </CCol>
                <CCol col="2">
                  <select v-model="selected_type" class="form-control"

                  >
                    <option value="0">
                      {{ $t('all') }}
                    </option>
                    <option value="1">
                      {{ $t('sell') }}
                    </option>
                    <option value="2">
                      {{ $t('buy') }}
                    </option>

                  </select>
                </CCol>
                <CCol>
                  <date-picker
                      :label="$t('components.startDate')"
                      v-model="start_date"></date-picker>
                </CCol>
                <CCol>
                  <date-picker
                      :label="$t('components.endDate')"
                      v-model="end_date"></date-picker>
                </CCol>
              </CRow>
            </CCol>

            <CCol>
              <CCard class="p-1">
                <CRow>
                  <!--                          <CCol col="2">-->
                  <!--                            {{ $t('meghdar') }}-->
                  <!--                          </CCol>-->
                  <!--                          <CCol col="3">-->
                  <!--                            {{ $t('TotalExistence') }}: {{ total_existance }}-->
                  <!--                          </CCol>-->
                  <!--                          <CCol col="3">-->
                  <!--                            {{ $t('InventoryExistence') }}: {{ total_existance }}-->
                  <!--                          </CCol>-->


                </CRow>
                <CRow>
                  <!--                          <CCol col="2">-->
                  <!--                            {{ $t('arzesh') }} {{currency_symbol()}}-->
                  <!--                          </CCol>-->
                  <!--                          <CCol col="3">-->
                  <!--                            {{ $t('TotalExistence') }}: {{ total_existance }}-->

                  <!--                          </CCol>-->
                  <!--                          <CCol col="3">-->
                  <!--                            {{ $t('InventoryExistence') }}: {{ total_existance }}-->
                  <!--                          </CCol>-->

                </CRow>
                <CRow>
                  <CCol col="12">
                    <input-tag v-model="selected_locations" :allow-duplicates="false"
                               style="min-height: 30px" :read-only="false"></input-tag>
                  </CCol>
                </CRow>

              </CCard>
            </CCol>
          </CRow>

          <!--                  <CRow>-->
          <!--                        <CCol>-->
          <!--                            <date-picker-->
          <!--                                    :label="$t('components.startDate')"-->
          <!--                                    v-model="start_date"></date-picker>-->
          <!--                        </CCol>-->
          <!--                        <CCol>-->
          <!--                            <date-picker-->
          <!--                                    :label="$t('components.endDate')"-->
          <!--                                    v-model="end_date"></date-picker>-->
          <!--                        </CCol>-->
          <!--                        <CCol>-->
          <!--                            <CSelect-->
          <!--                                :label="$t('tables.type')"-->
          <!--                                    horizontal-->
          <!--                                    :value.sync="selected_type_parent"-->
          <!--                                    :options="types_parent"-->
          <!--                            />-->
          <!--                        </CCol>-->
          <!--                        <CCol v-if="get_child_options().length>1">-->
          <!--                            <CSelect-->
          <!--                                    horizontal-->
          <!--                                    :value.sync="selected_type_child"-->
          <!--                                    :options="get_child_options()"-->
          <!--                            />-->
          <!--                        </CCol>-->


          <!--                        <CCol >-->
          <!--                            <treeselect-->
          <!--                                    v-model="selected_product"-->
          <!---->
          <!--                                    :normalizer="normalizer_products"-->
          <!--                                    :async="true"-->
          <!--                                    :loadOptions="load_products"-->
          <!--                                    :placeholder="$t('components.searchProduct')"-->
          <!--                            />-->
          <!--                        </CCol>-->


          <!--                    </CRow>-->
          <CCardBody>
            <CDataTableFixed
                :items="items_customer"
                :fields="fields"
                @row-clicked="table_row_clicked"
height="350px"
                :items-per-page="20"
                hover
                sorter
                column-filter
                border
                striped
            >
              <template #row_id="{item,index}">
                <td>
                  <p style="text-align: center">{{ index + 1 }}</p>
                </td>
              </template>
              <template #productCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.productCode }}</p>
                </td>
              </template>

              <template #amount="{item}">
                <td>
                  <p style="text-align: center">{{ item.amount }}</p>
                </td>
              </template>
              <template #docDate="{item}">
                <td>
                  <p>{{ get_date(item.docDate) }}</p>
                </td>
              </template>
              <template #amountNegetive="{item}">
                <td>
                  <p>{{ item.amountNegetive }}</p>
                </td>
              </template>
              <template #accBalance="{item}">
                <td>
                  <p>{{ item.accBalance }}</p>
                </td>
              </template>
              <template #accBalanceNegetive="{item}">
                <td>
                  <p>{{ item.accBalanceNegetive }}</p>
                </td>
              </template>

              <template #kardexAccTypeTitle="{item}">
                <td>
                  <strong>{{ item.kardexAccTypeTitle }}</strong>
                </td>
              </template>

              <template #masterId="{item}">
                <td>
                  <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                    {{ item.masterId }}
                    <CIcon name="cil-speedometer"/>
                  </a>

                </td>

              </template>

              <template #summary="{item}">
                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                </td>

              </template>

              <template #operation="{item}">
                <td>
                  <CButton
                      class="m-1"
                      color="primary"
                      variant="outline"
                      square
                      :title="$t('buttons.edit')"

                      size="sm"
                      @click="goEditPerson(item)"
                  >
                    <CIcon name="cil-pencil"/>
                  </CButton>
                  <CButton class="m-1"
                           color="success"
                           variant="outline"
                           square
                           size="sm"
                           :title="$t('buttons.documents')"
                           @click="goToDocuments(item)"
                  >
                    <CIcon name="cil-list-rich"/>
                  </CButton>

                </td>
              </template>


              <template #bgInvQty="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.bgInvQty) }}</p>
                </td>
              </template>
              <template #bgInvAmt="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.bgInvAmt) }}</p>
                </td>
              </template>


              <template #sumExistanceP="{item}">
                <td>
                  <p style="text-align: right">{{ (get_currency(item.sumExistanceP)) }}</p>
                </td>
              </template>
              <template #sumExistanceN="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(Math.abs(item.sumExistanceN)) }}</p>
                </td>
              </template>
              <template #sumAmountP="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.sumAmountP) }}</p>

                </td>
              </template>

              <template #sumAmountN="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(Math.abs(item.sumAmountN)) }}</p>
                </td>
              </template>
              <template #orginalExistance="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.orginalExistance) }}</p>
                </td>
              </template>


              <template #balanceAmount="{item}">
                <td>
                  <p style="text-align: right">{{ get_currency(item.balanceAmount) }}</p>
                </td>
              </template>

              <template #caption>
                <tr class="total-table">
                  <td>{{ $t('totalCirculation') }}</td>
                  <td></td>
                  <td></td>
                  <td></td>


                  <td >{{ get_currency(calculate_items(items_customer, 'bgInvAmt')) }}</td>
                  <td></td>
                  <td >{{ get_currency(calculate_items(items_customer, 'sumAmountP')) }}</td>
                  <td></td>
                  <td >{{ get_currency(Math.abs(calculate_items(items_customer, 'sumAmountN'))) }}</td>
                  <td></td>
                  <td >{{ get_currency(calculate_items(items_customer, 'balanceAmount')) }}</td>
                </tr>
                <!--                                <CRow >-->
                <!--                                    <CCol></CCol>-->
                <!--                                    <CCol></CCol>-->
                <!--                                    <CCol></CCol>-->
                <!--                                    <CCol></CCol>-->
                <!--                                    <CCol></CCol>-->
                <!--                                    <CCol class="bg-dark">{{$t('tables.balance')}}</CCol>-->
                <!--                                    <CCol class="bg-dark">{{get_sum_existance(items_customer.filter(x=>x.sumExistance>0)) +get_sum_existance(items_customer.filter(x=>x.sumExistance<0)) }}</CCol>-->
                <!--                                    <CCol></CCol>-->
                <!--                                </CRow>-->

              </template>

            </CDataTableFixed>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../../main';
import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      items_customer: [],
      start_date: '',
      selected_type: 0,

      types_all: [],
      types_parent: [],
      selected_type_parent: 0,
      selected_type_child: 0,
      selected_place: 0,
      places_items: [],

      end_date: '',
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'productCode', label: this.$t('components.itemCode'), _style: 'width:10%'},
        {key: 'productName', label: this.$t('item'), _style: 'width:10%'},
        {key: 'bgInvQty', label: this.$t('beginningInveQty'), _style: 'width:10%'},
        {key: 'bgInvAmt', label: this.$t('beginningInveAmt'), _style: 'width:10%'},
        // {key: 'accCode', label: this.$t('docNumber'), _style: 'width:10%'},

        {key: 'sumExistanceP', label: this.$t('income_qty'), _style: 'width:10%'},
        {key: 'sumAmountP', label: this.$t('income_price'), _style: 'width:10%'},

        {key: 'sumExistanceN', label: this.$t('outgoing_qty'), _style: 'width:10%'},
        {key: 'sumAmountN', label: this.$t('outgoing_price'), _style: 'width:10%'},
        {key: 'orginalExistance', label: this.$t('stockQty'), _style: 'width:10%'},
        {key: 'balanceAmount', label: this.$t('stockAmt'), _style: 'width:10%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],
      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode + " " + node.accountName,
        }
      },
      normalizer_accounting_tafzili(node) {
        return {
          id: node.recId,
          label: node.title,
        }
      },
      load_products({action, searchQuery, callback}) {
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },
      templates_items: [],
      accounting_list: [],
      moein_list: [],
      tafsili_list: [],
      selected_product: null,
      selected_moein: null,
      selected_tafsili: null,
      collapseDuration: 0,
      person_name: '',
      table_clicks: 0,
      table_clicks_timer: null,
      status_form: 0
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_places();
    this.get_types();
    // this.get_lists();
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_tafsili': function () {
      // this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        this.table_clicks = 0;
        clearTimeout(this.table_clicks_timer);
        // console.log("item clicked in ",item)
        // bus.$emit('product_cardex_selected',{label:item.productName,
        //   productId:item.productId,
        // start_date:this.start_date,end_date:this.end_date})
        // window.open("/dashboard/products/inventory-cardex-reports/"+item.productCode+" "+item.productName+"/"+item.productId+"/"+this.start_date+"/"+this.end_date)
        window.open("/dashboard/accounting/accounting-cardex-reports/" + item.productCode + " " + item.productName + "/" + item.productId + "/" + this.start_date + "/" + this.end_date)
      }

    },
    get_places() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetPlaces', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.places_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_sum_existance(list) {
      var sum = 0;
      list.forEach((val) => {
        sum += val.sumExistance;
      })
      return sum;
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    get_lists() {
      var self = this;
      //

      const formData = new FormData();

      var url = "GetCurrentExistsItems";

      if (this.selected_product == null) {
        formData.append('ProductId', 0);

      } else {
        formData.append('ProductId', this.selected_product);

      }
      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);
      formData.append('Place', this.selected_place);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });

          self.items_customer.forEach(function (val) {

            val.sumExistanceP = val.inputQty //* val.value
            val.sumExistanceN = val.outputQty //* val.value

            val.orginalExistance = val.bgInvQty + val.inputQty + val.outputQty
            val.orginalExistance = val.orginalExistance //* val.value

            val.sumAmountP = val.inputAmt //* val.value //* val.inputQty
            val.sumAmountN = val.outputAmt //* val.value //* val.outputQty

            val.balanceAmount = val.bgInvAmt + val.inputAmt + val.outputAmt
            // val.balanceAmount = val.balanceAmount //* val.value //* val.orginalExistance
          })

          // self.templates_items = content_data.data;
          // self.total_existance = self.items[0].orginalExistance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },

    get_types() {
      var self = this;


      const formData = new FormData();

      var url = "GetReportNumberList";

      // formData.append('id', "1532");
      //
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var data_get = self.sort_array([], content_data.data
              , "id", "title");
          self.types_all = data_get.filter(x => x.typeId == 2);
          self.types_parent = data_get.filter(x => x.parentId == 0 && x.typeId == 2);
          self.selected_type_parent = self.types_parent[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_child_options() {
      var array = [{label: this.$t('select'), value: 0}];
      var newArray = array.concat(this.types_all.filter(x => x.parentId == this.selected_type_parent));
      return newArray
    }

  }
}

</script>
